import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuardarProyectoComponent } from '../../components/guardar-proyecto/guardar-proyecto.component';

@Component({
	standalone: true,
	imports: [
		CommonModule, 
		GuardarProyectoComponent],
	templateUrl: './guardar-proyecto.view.html',
	styleUrls: ['./guardar-proyecto.view.scss'],
	host: {
		'data-view-id': 'guardar-proyecto-view'
	}
})
export class GuardarProyectoView {}
